import { takeLatest } from 'redux-saga/effects';
import { call } from 'redux-saga/effects';
import AT from '../constants/action-types';
import { restartControlBox, reloadControlBox, configDisplay, sendCbxConfig, cbxUpdate } from '../api';

import { reloadProviderData } from './helpers/reload-provider-data';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* processControlBoxCommandSaga(action: any) {
  const { id, cmd, address } = action;
  switch (cmd) {
    case 'cbx-restart': {
      yield call(restartControlBox, id);
      break;
    }
    case 'cbx-reload': {
      yield call(reloadControlBox, id);
      break;
    }
    case 'send-cbx-config': {
      yield call(sendCbxConfig, id);
      break;
    }
    case 'cbx-update': {
      yield call(cbxUpdate, id);
      break;
    }
    case 'config-display': {
      yield call(configDisplay, id, address);
      break;
    }
    default: {
      throw new Error(`Unknown cbx command ${cmd}`);
    }
  }
  yield reloadProviderData();
}

export default function* controlBoxCommandSaga() {
  yield takeLatest(AT.CONTROL_BOX_COMMAND_SAGA, processControlBoxCommandSaga);
}
